import React, { useState, useRef, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { c } from '@debbie/cortex/dist';
import { Input, Button } from '..';
const TwoFactor = (props) => {
    const lang = useSelector((s) => s.lang);
    const [token, setToken] = useState('');
    const ref = useRef(null);
    useEffect(() => {
        if (ref.current != null) {
            ref.current.focus();
        }
    });
    return (React.createElement("div", null,
        React.createElement("form", { onSubmit: (e) => {
                e.preventDefault();
                e.stopPropagation();
                c.auth.verifyTwoFactor(props.username, props.password, token);
            } },
            React.createElement("p", null, lang.login.twoFactorExplainer),
            React.createElement(Input, { placeholder: lang.login.twoFactorPlaceholder, onChange: (e) => {
                    setToken(e.target.value);
                }, inputRef: ref, value: token }),
            React.createElement(Button, { block: true, style: { marginBottom: '10px' } }, lang.misc.approve))));
};
export default TwoFactor;
//# sourceMappingURL=TwoFactor.js.map